import React,{useEffect,useRef,useState} from 'react';
const {startCheckoutActivation}=require('./checkoutActivationController');
export default function CheckoutActivation({onRefresh,onConfirmed}){
  const callbacks=useRef({onRefresh,onConfirmed});
  callbacks.current={onRefresh,onConfirmed};
  const [state,setState]=useState('checking');
  const [retry,setRetry]=useState(0);
  useEffect(()=>startCheckoutActivation({
    refresh:()=>callbacks.current.onRefresh(),
    onState:setState,
    onConfirmed:()=>callbacks.current.onConfirmed(),
  }),[retry]);
  return <section className="panel" aria-labelledby="checkout-activation-title">
    <h1 id="checkout-activation-title">Activating your Lotto Tracker Pro membership</h1>
    <p role="status" aria-live="polite" style={{margin:'16px 0',lineHeight:1.5}}>
      {state==='waiting'?'Pro activation is still processing or could not yet be confirmed. Check again shortly.':'We’re confirming your Pro access. You’ll automatically arrive at your Dashboard when it’s ready.'}
    </p>
    <p style={{marginBottom:16}}>You do not need to subscribe again.</p>
    {state==='waiting'&&<button type="button" className="btn btn-p" onClick={()=>{setState('checking');setRetry(n=>n+1);}}>Check activation again</button>}
    <p style={{fontSize:13}}>Need help? <a href="mailto:support@lottotracker.app">Contact Lotto Tracker support</a>.</p>
  </section>;
}
